import React from "react";
import { Link } from "react-router-dom";
import classes from "./FooterThird.module.css";
function FooterThird() {
  return (
    <div className={classes["footer_three"]}>
      <section>
        <ul className={classes["footer_details-container"]}>
          <li className={classes["footer_details"]}>
            <h1 className={classes["footer-third-title"]}>
              The Leading Online Shopping Mall in pakistan
            </h1>
            <p>
              <span>
                muradi pakistan "(Ecart Services pakistan Sdn Bhd (983365-K)" is
                pioneering e-commerce across some of the fastest growing
                countries in the world by offering a fast, secure and convenient
                online shopping experience with a broad product offering in
                categories ranging from fashion, consumer electronics to
                household goods, toys and sports equipment. muradi is always
                striving to offer its customers the best possible offering –
                including multiple payment options, free returns and extensive
                customer service and warranty commitments.
              </span>
            </p>
            <p>
              <span>
                We are constantly expanding our product range as well like
                recently the Fashion and Watches category. We offer the best
                selection of quality products you'll find anywhere all at your
                fingertips. Online shopping in pakistan has never been this
                easy! Stay connected and stay tuned for new offers and deals we
                have from time to time. Remember, everyday is a shopping day on
                muradi!
              </span>
            </p>
            <p>
              <span>
                We are constantly expanding our product range as well like
                recently the Fashion and Watches category. We offer the best
                selection of quality products you'll find anywhere all at your
                fingertips. Online shopping in pakistan has never been this
                easy! Stay connected and stay tuned for new offers and deals we
                have from time to time. Remember, everyday is a shopping day on
                muradi!
              </span>
            </p>
            <p>
              <span>
                Last but not the least, we want to emphasize that we're more
                than just one of the pakistan's largest online ecommerce stores.
                It is our highest priority here at muradi.com.my to create the
                best online shopping experience for every customer in pakistan.
                So start your online shopping and remember if you have questions
                we are just a phone call or email away.
              </span>
            </p>
          </li>
          <li className={classes["footer_details"]}>
            <h3 className={classes["footer-third-title"]}>Easy Shopping</h3>
            <p>
              <span>
                It has been our goal throughout the years to provide an
                “Effortless shopping” experience for every customer, promising a
                hassle-free, convenient, and positive online shopping
                experience. Our extensive offerings combined with our
                user-freindly Website and App allows customers to find
                everything they need. Customers can search for a produuct
                through brand, category, or keywords, check out detailed
                descriptions as well as genuine customer reviews to help make
                purchase decisions. On top of that with
              </span>
            </p>
            <h3 className={classes["footer-third-title"]}>
              The Biggest Sales, Best Vouchers &amp; Top Promos
            </h3>
            <p>
              <span>
                Check in daily on muradi for attractive deals on your favorite
                items. Buy more save more, collect vouchers, stack them and get
                a bang for your buck. Get your
              </span>
              <Link to={"#"} target="_self">
                <span className={classes["special_link"]}>muradi Wallet</span>
              </Link>

              <span>
                ready for incredible deals during our campaign periods including
              </span>

              <Link to={"#"} target="_self">
                <span className={classes["special_link"]}>Birthday Sale</span>
              </Link>

              <span>,</span>

              <Link to={"#"} target="_self">
                <span className={classes["special_link"]}>Mid Year Sale</span>
              </Link>
              <span>, </span>

              <Link to={"#"} target="_self">
                <span className={classes["special_link"]}>9.9</span>
              </Link>

              <span>,</span>

              <Link to={"#"} target="_self">
                <span className={classes["special_link"]}>10.10</span>
              </Link>

              <span>
                and muradi’s most anticipated online shopping festivals:
              </span>

              <Link to={"#"} target="_self">
                <span className={classes["special_link"]}>11.11</span>
              </Link>

              <span>and</span>

              <Link to={"#"} target="_self">
                <span className={classes["special_link"]}>12.12</span>
              </Link>

              <span>Sales! Check out </span>
              <Link to={"#"} target="_self">
                <span className={classes["special_link"]}>
                  Every Day Low Price
                </span>
              </Link>

              <span>too for daily low price deals. </span>
            </p>
            <p>
              <span>
                Last but not the least, we want to emphasize that we're more
                than just one of the pakistan's largest online ecommerce stores.
                It is our highest priority here at muradi.com.my to create the
                best online shopping experience for every customer in pakistan.
                So start your online shopping and remember if you have questions
                we are just a phone call or email away.
              </span>
            </p>
            <h3 className={classes["footer-third-title"]}>WHAT'S NEW?</h3>
            <p>
              <Link to={"#"} target="_self">
                <span>Muradi mall</span>
              </Link>
              <span>,</span>
              <Link to={"#"} target="_self">
                <span>Tmall Signature</span>
              </Link>
              <span>,</span>
              <Link to={"#"} target="_self">
                <span>Vouchers</span>
              </Link>
              <span>,</span>
              <Link to={"#"} target="_self">
                <span>Fashion Deals</span>
              </Link>
              <span>,</span>
              <Link to={"#"} target="_self">
                <span>iPhone X deals</span>
              </Link>
              <span>,</span>
              <Link to={"#"} target="_self">
                <span>Samsung Galaxy Note 8</span>
              </Link>
              <span>,</span>
              <Link to={"#"} target="_self">
                <span>New Surface Pro</span>
              </Link>
              <span>,</span>
              <Link to={"#"} target="_self">
                <span>Nexus 6p</span>
              </Link>
              <span>,</span>
              <Link to={"#"} target="_self">
                <span>Samsung Galaxy S9</span>
              </Link>
              <span>,</span>
              <Link to={"#"} target="_self">
                <span>Samsung Galaxy S8</span>
              </Link>
              <span>,</span>
              <Link to={"#"} target="_self">
                <span>Samsung Galaxy S8+</span>
              </Link>
              <span>,</span>
              <Link to={"#"} target="_self">
                <span>Hand Fidget Spinner</span>
              </Link>
            </p>
          </li>
          <li className={classes["footer_details"]}>
            <h1 className={classes["footer-third-title"]}>
              The Leading Online Shopping Mall in pakistan
            </h1>
            <p>
              <span>
                muradi pakistan "(Ecart Services pakistan Sdn Bhd (983365-K)" is
                pioneering e-commerce across some of the fastest growing
                countries in the world by offering a fast, secure and convenient
                online shopping experience with a broad product offering in
                categories ranging from fashion, consumer electronics to
                household goods, toys and sports equipment. muradi is always
                striving to offer its customers the best possible offering –
                including multiple payment options, free returns and extensive
                customer service and warranty commitments.
              </span>
            </p>
            <p>
              <span>
                We are constantly expanding our product range as well like
                recently the Fashion and Watches category. We offer the best
                selection of quality products you'll find anywhere all at your
                fingertips. Online shopping in pakistan has never been this
                easy! Stay connected and stay tuned for new offers and deals we
                have from time to time. Remember, everyday is a shopping day on
                muradi!
              </span>
            </p>
            <p>
              <span>
                We are constantly expanding our product range as well like
                recently the Fashion and Watches category. We offer the best
                selection of quality products you'll find anywhere all at your
                fingertips. Online shopping in pakistan has never been this
                easy! Stay connected and stay tuned for new offers and deals we
                have from time to time. Remember, everyday is a shopping day on
                muradi!
              </span>
            </p>
            <p>
              <span>
                Last but not the least, we want to emphasize that we're more
                than just one of the pakistan's largest online ecommerce stores.
                It is our highest priority here at muradi.com.my to create the
                best online shopping experience for every customer in pakistan.
                So start your online shopping and remember if you have questions
                we are just a phone call or email away.
              </span>
            </p>
          </li>
          <li className={classes["footer_details"]}>
            <h1 className={classes["footer-third-title"]}>
              The Leading Online Shopping Mall in pakistan
            </h1>
            <p>
              <span>
                muradi pakistan "(Ecart Services pakistan Sdn Bhd (983365-K)" is
                pioneering e-commerce across some of the fastest growing
                countries in the world by offering a fast, secure and convenient
                online shopping experience with a broad product offering in
                categories ranging from fashion, consumer electronics to
                household goods, toys and sports equipment. muradi is always
                striving to offer its customers the best possible offering –
                including multiple payment options, free returns and extensive
                customer service and warranty commitments.
              </span>
            </p>
            <p>
              <span>
                We are constantly expanding our product range as well like
                recently the Fashion and Watches category. We offer the best
                selection of quality products you'll find anywhere all at your
                fingertips. Online shopping in pakistan has never been this
                easy! Stay connected and stay tuned for new offers and deals we
                have from time to time. Remember, everyday is a shopping day on
                muradi!
              </span>
            </p>
            <p>
              <span>
                We are constantly expanding our product range as well like
                recently the Fashion and Watches category. We offer the best
                selection of quality products you'll find anywhere all at your
                fingertips. Online shopping in pakistan has never been this
                easy! Stay connected and stay tuned for new offers and deals we
                have from time to time. Remember, everyday is a shopping day on
                muradi!
              </span>
            </p>
            <p>
              <span>
                Last but not the least, we want to emphasize that we're more
                than just one of the pakistan's largest online ecommerce stores.
                It is our highest priority here at muradi.com.my to create the
                best online shopping experience for every customer in pakistan.
                So start your online shopping and remember if you have questions
                we are just a phone call or email away.
              </span>
            </p>
          </li>
        </ul>
      </section>
    </div>
  );
}

export default FooterThird;
